import * as React from 'react';

import { ZoomInButton } from './ZoomInButton';
import { useMapContext } from '../../../context';
import { useTrackMapInteraction } from '../../../utils/useTrackMapInteraction';

export const ZoomInButtonContainer: React.FC = props => {
  const { map } = useMapContext();
  const trackMapInteractions = useTrackMapInteraction();

  return <ZoomInButton {...props} map={map} onClick={trackMapInteractions} />;
};
